import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex-column flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DetailMessage = _resolveComponent("DetailMessage")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.communications, (comm) => {
      return (_openBlock(), _createElementBlock("div", {
        key: comm.id,
        class: _normalizeClass(["flex flex-wrap mb-2", `${comm.received ? 'justify-content-start' : 'justify-content-end' }`])
      }, [
        _createVNode(_component_DetailMessage, {
          internal: this.internal,
          message: comm,
          communication: true
        }, null, 8, ["internal", "message"])
      ], 2))
    }), 128))
  ]))
}